import axios, { AxiosResponse } from 'axios';

export type Review = {
  blurb: string;
  date: string;
  name: string;
  rating: number;
  state: string;
  wholeReview: string;
};

type ReviewEntryV4 = { id: number; attributes: Review };
type ReviewEntryV5 = { id: number; documentId: string } & Review;
export type ReviewEntry = ReviewEntryV4 | ReviewEntryV5;

export function normalizeReviewEntry(entry: ReviewEntry): Review {
  if ('attributes' in entry && entry.attributes != null) {
    return entry.attributes;
  }
  const { blurb, date, name, rating, state, wholeReview } = entry as ReviewEntryV5;
  return { blurb, date, name, rating, state, wholeReview };
}

const strapiUri = `${process.env.CARVANA_APP_API_BASE}/stc/cms/api`;

const getCustomerReviews = async (): Promise<AxiosResponse<{ data: ReviewEntry[] }>> =>
  axios.get(`${strapiUri}/customer-reviews`);

export { getCustomerReviews };
